module.exports = __webpack_public_path__ + "static/media/escarapela.5beb30ed.png";